import { createRecipe } from './runtime';

const textareaConfig = {"name":"textarea","defaultVariants":{"size":"md"},"variantMap":{"size":["lg","md","sm","xl"]}}

export const textarea = /* @__PURE__ */ createRecipe(textareaConfig)